import {
    INIT_APP, INIT_APP_RESPONSE, VARIFY_OTP, VARIFY_OTP_RESPONSE, MYZONE_RESPONSE,
    VALIDATE_USER_RESPONSE, USER_LOG_RESPONSE, LOGIN_ATTEMPT_RESPONSE, GET_STRATEGY_RESPONSE,
    REPORT_SEND_RESPONSE, USER_ID_RESPONSE, GET_ACCOUNT_PERFORMANCE_RESPONSE,
    GET_ACCOUNT_PERFORMANCE_FAILED, GET_CAPITAL_MOVEMENT_RESPONSE, GET_CAPITAL_MOVEMENT_FAILED,
    GET_CORPORATE_ACTION_RESPONSE, GET_CORPORATE_ACTION_FAILED, GET_DEBIT_NOTE_RESPONSE,
    GET_DEBIT_NOTE_FAILED, GET_TAXIBLE_GAIN_RESPONSE, GET_TAXIBLE_GAIN_FAILED,
    GET_HOLDING_STATEMENT_RESPONSE, GET_HOLDING_STATEMENT_FAILED,
    GET_AUDIT_REPORT_YEARS_RESPONSE, GET_AUDIT_REPORT_YEARS_FAILED, GET_AUDIT_REPORT_RESPONSE,
    GET_AUDIT_REPORT_STRATEGY_RESPONSE,
    GET_AUDIT_REPORT_STRATEGY_FAILED, GET_AUDIT_REPORT_FAILED, GET_ACCOUNT_STATEMENT_FAILED, GET_ACCOUNT_STATEMENT_RESPONSE, GET_MF_ACCOUNT_STATEMENT_RESPONSE,
    GET_MF_ACCOUNT_STATEMENT_FAILED, STRATEGY_CODE_RESPONSE, STRATEGY_CODE_FAILED, STRATEGY_CODE, GET_MF_CAPITAL_GAIN_LOSS_RESPONSE, GET_MF_CAPITAL_GAIN_LOSS_FAILED,
    CHECK_PMS_DIT_PAN_RESPONSE, CHECK_PMS_DIT_PAN_FAILED, CHECK_AIF_DIT_PAN_FAILED, CHECK_AIF_DIT_PAN_RESPONSE,
    PMS_GET_AUDIT_REPORT_STRATEGY_RESPONSE, PMS_GET_AUDIT_REPORT_STRATEGY_FAILED, GET_ACCOUNT_PERFORMANCE_GROUP_WIS_RESPONSE,
    GET_ACCOUNT_PERFORMANCE_GROUP_WIS_FAILED, GET_FRACTION_LEDGER_RESPONSE, GET_FRACTION_LEDGER_FAILED,
    PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_RESPONSE, PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_FAILED, GET_MF_ACCOUNT_STATEMENT_INVESTOR_RESPONSE, GET_MF_ACCOUNT_STATEMENT_INVESTOR_FAILED, CHECK_MF_PAN_DIST_RESPONSE, CHECK_MF_PAN_DIST_FAILED,
    AUTHENTICATE_USER_BY_PAN_RESPONSE, AUTHENTICATE_USER_BY_TOKEN_RESPONSE, LOGOUT
} from '../types/initApp';

const initialState = {
    initDetails: "",
    myzone: "",
    validateUser: "",
    log: "",
    loginAttempt: "",
    getStratergy: "",
    reportSend: "",
    userId: "",
    getAccountPerformance: {},
    getCapitalMovement: [],
    getCorporateAction: {},
    getDebitNote: {},
    getTaxaibleGain: {},
    getHoldingStatement: {},
    getAuditReportYears: {},
    getAuditReport: {},
    getAuditReportStrategy: {},
    getAccountStatement: {},
    getMFAccountStatement: {},
    getStratergycode: [],
    getMfCapitalGainLoss: {},
    pmsDitPan: {},
    aifDitPan: {},
    pmsGetAuditReportStrategy: {},
    getAccountPerformanceGroupwis: {},
    getFractionLedger: {},
    pmsRealisedCapitalGainLossReport: {},
    getMFAccountStatementInvestor: {},
    CheckMFPanDist: {},
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case INIT_APP_RESPONSE:
            return { ...state, initDetails: action.payload }
        case LOGOUT:
            return { ...state, myzone: "", userId: "" }
        case VARIFY_OTP:
            return { ...state, ...action.payload }
        case VARIFY_OTP_RESPONSE:
            return { ...state, initDetails: action.payload }
        case MYZONE_RESPONSE:
            return { ...state, myzone: action.payload }
        case VALIDATE_USER_RESPONSE:
            return { ...state, validateUser: action.payload }
        case USER_LOG_RESPONSE:
            return { ...state, log: action.payload }
        case LOGIN_ATTEMPT_RESPONSE:
            return { ...state, loginAttempt: action.payload }
        case GET_STRATEGY_RESPONSE:
            return { ...state, getStratergy: action.payload }
        case REPORT_SEND_RESPONSE:
            return { ...state, reportSend: action.payload }
        case USER_ID_RESPONSE:
            return { ...state, userId: action.payload }

        case GET_ACCOUNT_PERFORMANCE_RESPONSE:
            return { ...state, getAccountPerformance: action.payload }
        case GET_ACCOUNT_PERFORMANCE_FAILED:
            return { ...state, getAccountPerformance: action.payload }

        case GET_CAPITAL_MOVEMENT_RESPONSE:
            return { ...state, getCapitalMovement: action.payload }
        case GET_CAPITAL_MOVEMENT_FAILED:
            return { ...state, getCapitalMovement: action.payload }

        case GET_CORPORATE_ACTION_RESPONSE:
            return { ...state, getCorporateAction: action.payload }
        case GET_CORPORATE_ACTION_FAILED:
            return { ...state, getCorporateAction: action.payload }

        case GET_DEBIT_NOTE_RESPONSE:
            return { ...state, getDebitNote: action.payload }
        case GET_DEBIT_NOTE_FAILED:
            return { ...state, getDebitNote: action.payload }

        case GET_TAXIBLE_GAIN_RESPONSE:
            return { ...state, getTaxaibleGain: action.payload }
        case GET_TAXIBLE_GAIN_FAILED:
            return { ...state, getTaxaibleGain: action.payload }

        case GET_HOLDING_STATEMENT_RESPONSE:
            return { ...state, getHoldingStatement: action.payload }
        case GET_HOLDING_STATEMENT_FAILED:
            return { ...state, getHoldingStatement: action.payload }

        case GET_AUDIT_REPORT_YEARS_RESPONSE:
            return { ...state, getAuditReportYears: action.payload }
        case GET_AUDIT_REPORT_YEARS_FAILED:
            return { ...state, getAuditReportYears: action.payload }

        case GET_AUDIT_REPORT_RESPONSE:
            return { ...state, getAuditReport: action.payload }
        case GET_AUDIT_REPORT_FAILED:
            return { ...state, getAuditReport: action.payload }

        case GET_AUDIT_REPORT_STRATEGY_RESPONSE:
            return { ...state, getAuditReportStrategy: action.payload }
        case GET_AUDIT_REPORT_STRATEGY_FAILED:
            return { ...state, getAuditReportStrategy: action.payload }
        case PMS_GET_AUDIT_REPORT_STRATEGY_RESPONSE:
            return { ...state, pmsGetAuditReportStrategy: action.payload }
        case PMS_GET_AUDIT_REPORT_STRATEGY_FAILED:
            return { ...state, pmsGetAuditReportStrategy: action.payload }
        case GET_ACCOUNT_STATEMENT_RESPONSE:
            return { ...state, getAccountStatement: action.payload }
        case GET_ACCOUNT_STATEMENT_FAILED:
            return { ...state, getAccountStatement: action.payload }
        case GET_MF_ACCOUNT_STATEMENT_RESPONSE:
            return { ...state, getMFAccountStatement: action.payload }
        case GET_MF_ACCOUNT_STATEMENT_FAILED:
            return { ...state, getMFAccountStatement: action.payload }
        case GET_MF_CAPITAL_GAIN_LOSS_RESPONSE:
            return { ...state, getMfCapitalGainLoss: action.payload }
        case GET_MF_CAPITAL_GAIN_LOSS_FAILED:
            return { ...state, getMfCapitalGainLoss: action.payload }
        case CHECK_PMS_DIT_PAN_RESPONSE:
            return { ...state, pmsDitPan: action.payload }
        case CHECK_PMS_DIT_PAN_FAILED:
            return { ...state, pmsDitPan: action.payload }
        case CHECK_AIF_DIT_PAN_RESPONSE:
            return { ...state, aifDitPan: action.payload }
        case CHECK_AIF_DIT_PAN_FAILED:
            return { ...state, aifDitPan: action.payload }
        case STRATEGY_CODE:
            // let aaa = []
            // aaa = state.getStratergycode;
            // aaa.push(action.payload)
            let aaa = action.payload
            console.log("aaa", aaa, action.payload);

            return {
                ...state,
                getStratergycode: aaa,
            }

        case GET_ACCOUNT_PERFORMANCE_GROUP_WIS_RESPONSE:
            return { ...state, getAccountPerformanceGroupwis: action.payload }
        case GET_ACCOUNT_PERFORMANCE_GROUP_WIS_FAILED:
            return { ...state, getAccountPerformanceGroupwis: action.payload }
        case GET_FRACTION_LEDGER_RESPONSE:
            return { ...state, getFractionLedger: action.payload }
        case GET_FRACTION_LEDGER_FAILED:
            return { ...state, getFractionLedger: action.payload }
        case PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_RESPONSE:
            return { ...state, pmsRealisedCapitalGainLossReport: action.payload }
        case PMS_REALISED_CAPITAL_GAIN_LOSS_REPORT_FAILED:
            return { ...state, pmsRealisedCapitalGainLossReport: action.payload }
        case GET_MF_ACCOUNT_STATEMENT_INVESTOR_RESPONSE:
            return { ...state, getMFAccountStatementInvestor: action.payload }
        case GET_MF_ACCOUNT_STATEMENT_INVESTOR_FAILED:
            return { ...state, getMFAccountStatementInvestor: action.payload }
        case CHECK_MF_PAN_DIST_RESPONSE:
            return { ...state, CheckMFPanDist: action.payload }
        case CHECK_MF_PAN_DIST_FAILED:
            return { ...state, CheckMFPanDist: action.payload }
        default:
            return state
    }

}
